<dx-popup [dragEnabled]="!fullScreen"
  [showCloseButton]="false"
  [fullScreen]="fullScreen"
  [width]="width"
  [height]="height"
  [title]="title"
  [visible]="popupVisible">
  <div class="header-buttons">
    <dx-button [visible]="searchVisible" icon="search" [text]="languageService.LNG('Label.Button.Search')" (onClick)="onSearch()"></dx-button>
    <dx-button icon="close" [text]="languageService.LNG('Label.Button.Close')" (onClick)="closeClicked.emit()"></dx-button>
  </div>
  <ng-content></ng-content>
</dx-popup>
